import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentVerificationPopupComponent } from './document-verification-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DocumentVerificationPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule
],
  exports: [
    DocumentVerificationPopupComponent
  ]
})
export class DocumentVerificationPopupModule { }
